import { render, staticRenderFns } from "./CookiesModal.vue?vue&type=template&id=60a6582c&"
import script from "./CookiesModal.vue?vue&type=script&lang=js&"
export * from "./CookiesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports